/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  contextualFooter reducer
 */

import { payloadKeyReducer } from '@zcode/reducers'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import { RECEIVE_DIL_ADDRESSES } from '../constants/index'

const contextualFooterReducer = combineReducers({
  dilAddresses: handleActions(
    {
      [RECEIVE_DIL_ADDRESSES]: payloadKeyReducer('data'),
    },
    null
  ),
})

export default contextualFooterReducer
